import React from "react";

function CheckboxButton(props) {
    return (
        <label className={"search-checkbox-row calc__ins-row" + (props.disabled ? " calc__ins-row--disabled" : "")}>
            <input
                type="checkbox"
                checked={props.checked}
                onChange={props.onChange}
                disabled={props.disabled}
            />
            <span className="calc__ins-label">{props.title}</span>
            {props.label && <span className="calc__ins-price">{props.label}</span>}
        </label>
    );
}

export default CheckboxButton;
